import VendorForm from "kinnect-front/FacilityMaintenance/Vendors/VendorForm";
import DefaultLayout from "@/layouts/DefaultLayout";
import { FacilityMaintenanceVendor } from "kinnect-models";
import { Crudable, FetchesData, Pageable } from "kinnect-mixins";
import { KActionDialog } from "kinnect-general";

export default {
	name: "FacilityMaintenanceVendorPage",

	metaInfo() {
		const title = this.editing
			? "Facility Maintenance - View Vendor"
			: "Facility Maintenance - Add Vendor";

		return { title };
	},

	props: { idVendor: Number },

	mixins: [
		Crudable,
		FetchesData,
		Pageable
	],

	data: () => ( {
		crud: "facility_maintenance_vendors",
		deleteDialogOpen: false,
		facilityMaintenance: null
	} ),

	computed: {
		editing() {
			return Boolean( this.idVendor );
		},

		genDeleteDialog() {
			if ( this.editing && this.vendor && this.canDelete ) {
				return <KActionDialog
					confirmButtonColor="error"
					confirmButtonText="Delete"
					loading={this.$wait.is( "delete vendor" )}
					onConfirm={() => this.vendor.delete()}
					redirect={[ "back", { name: "facilityMaintenanceVendors" } ]}
					title="Delete Vendor"
					vModel={this.deleteDialogOpen}
				>
					Are you sure you want to delete the maintenance vendor <strong>{this.vendor.name}</strong>?
				</KActionDialog>;
			}
		},

		toolbarActions() {
			if ( this.editing && this.canDelete ) {
				return {
					icon: "delete",
					onClick: () => this.deleteDialogOpen = true,
					text: "Delete",
					tooltip: "Delete this maintenance vendor"
				};
			}
		}
	},

	methods: {
		async fetchVendor() {
			if ( this.editing ) {
				this.vendor = await FacilityMaintenanceVendor.findPageModel( this.idVendor );
			}
		},

		async fetch() {
			await this.fetchVendor();
		}
	},

	render() {
		return <DefaultLayout>
			<VendorForm
				loading={this.$wait.is( "find vendor" )}
				readonly={this.editing ? !this.canEdit : !this.canAdd}
				vendor={this.vendor}
			></VendorForm>

			{this.genDeleteDialog}
		</DefaultLayout>;
	}
};
